module.exports = __webpack_public_path__ + "static/img/gptModel51.38dc915e.png";